import {NgModule} from '@angular/core';
import {XxConfigPage} from './page/overview/config/xx-config.page';
import {XxTablePage} from './page/overview/tables/xx-table.page';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {XxWidgetPage} from './page/overview/widgets/xx-widget.page';
import {XxPersonExternalFlatComponent} from './page/overview/widgets/xx-person-external-flat.component';
import {XxPersonExternalTypedComponent} from './page/overview/widgets/xx-person-external-typed.component';
import {XxPersonDataComponent} from './page/overview/widgets/xx-person-data.component';
import {XxSidecarPlaygroundComponent} from './page/overview/playground/xx-sidecar-playground.component';
// TM-1000001960: unified Side-Car Playground shell + its uf-Erfassung tab
import {XxPlaygroundShellComponent} from './page/overview/playground/xx-playground-shell.component';
import {XxPlaygroundUfComponent} from './page/overview/playground/xx-playground-uf.component';
// "Berufe (TAA)" tab: search-backed cc.FieldValueList inside the generic CRUD form
import {XxPlaygroundBerufeComponent} from './page/overview/playground/xx-playground-berufe.component';
import {UfModule} from '../../feature-core/uf/uf.module';
import {CmModule} from '../../feature-crm/cm/cm.module';
import {XxTestComponentComponent} from './page/testComponent/test-component.component';
import {XxFormLogicComponent} from './page/overview/form-logic/xx-form-logic.component';
import {XxFormExternalSaveTestPage} from './page/test/xx-form-external-save-test.page';
// @ticket TM-1000002003
import {XxAutosaveFocusTestPage} from './page/test/xx-autosave-focus-test.page';
import {XxObjectDocumentComponent} from './page/object-documents/object-documents.component';
import {
    XxDialogBoxObjectDocumentComponent
} from './page/dialog-box-object-documents/dialog-box-object-documents.component';
import {DmModule} from '../../feature-core/dm/dm.module';
import {XxUserComponent} from './observer/component/xx-user.component';
import {CoreModule} from '../../core/core.module';
import {XX_TEST_PROVIDERS} from './test/xx-test-definition';
// Registers the xx entity -> REST route mapping in the shared dtoServiceMap. Every other module
// wires its own entity provider the same way; xx declared one but never provided it, so no xx entity
// was resolvable by MvsCoreService and any CRUD form on one failed with "DtoType not found".
import {X_ENTITY_PROVIDER} from './xx.entity-provider';

@NgModule({
    declarations: [
        XxConfigPage,
        XxTablePage,
        XxWidgetPage,
        XxPersonExternalFlatComponent,
        XxPersonExternalTypedComponent,
        XxPersonDataComponent,
        XxSidecarPlaygroundComponent,
        XxPlaygroundShellComponent,
        XxPlaygroundUfComponent,
        XxPlaygroundBerufeComponent,
        XxTestComponentComponent,
        XxObjectDocumentComponent,
        XxDialogBoxObjectDocumentComponent,
        XxUserComponent,
        XxFormLogicComponent,
        XxFormExternalSaveTestPage,
        XxAutosaveFocusTestPage,
    ],
    exports: [
        XxConfigPage,
        XxTablePage,
        XxWidgetPage,
        XxPersonExternalFlatComponent,
        XxPersonExternalTypedComponent,
        XxPersonDataComponent,
        XxSidecarPlaygroundComponent,
        XxPlaygroundShellComponent,
        XxPlaygroundUfComponent,
        XxPlaygroundBerufeComponent,
        XxTestComponentComponent,
        XxObjectDocumentComponent,
        XxDialogBoxObjectDocumentComponent,
        XxUserComponent,
        XxFormLogicComponent,
        XxFormExternalSaveTestPage,
        XxAutosaveFocusTestPage,
    ],
    imports: [
        CoreModule,
        ProgressSpinnerModule,
        CmModule,
        DmModule,
        UfModule
    ],
    providers: [X_ENTITY_PROVIDER, XX_TEST_PROVIDERS]
})
export class XxModule { }
